var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7749 2.33887C3.7749 1.45068 3.06104 0.736816 2.15625 0.736816C1.26807 0.736816 0.545898 1.45068 0.545898 2.33887C0.545898 3.22705 1.26807 3.94092 2.15625 3.94092C3.05273 3.94092 3.7749 3.22705 3.7749 2.33887ZM9.59375 2.33887C9.59375 1.45068 8.88818 0.736816 8 0.736816C7.11182 0.736816 6.39795 1.45068 6.39795 2.33887C6.39795 3.22705 7.11182 3.94092 8 3.94092C8.87988 3.94092 9.59375 3.22705 9.59375 2.33887ZM15.4458 2.33887C15.4458 1.45068 14.7319 0.736816 13.8438 0.736816C12.939 0.736816 12.2251 1.45068 12.2251 2.33887C12.2251 3.22705 12.939 3.94092 13.8438 3.94092C14.7236 3.94092 15.4458 3.22705 15.4458 2.33887Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.124d45580eb36179d45f16c84f366a41.svg";
export { ForwardRef as ReactComponent };